export const HYDRATE_AIRCRAFT_MODIFIERS = "HYDRATE_AIRCRAFT_MODIFIERS";
export const HYDRATE_AIRCRAFT_MODIFIERS_PENDING = "HYDRATE_AIRCRAFT_MODIFIERS_PENDING";
export const HYDRATE_AIRCRAFT_MODIFIERS_FULFILLED = "HYDRATE_AIRCRAFT_MODIFIERS_FULFILLED";
export const HYDRATE_AIRCRAFT_MODIFIERS_REJECTED = "HYDRATE_AIRCRAFT_MODIFIERS_REJECTED";

export const SELECT_AIRCRAFT_MODIFIERS = "SELECT_AIRCRAFT_MODIFIERS";

export const RESET_AIRCRAFT_MODIFIERS = "RESET_AIRCRAFT_MODIFIERS";
